import { Provider } from "@redotech/redo-order-common/provider";
import * as z from "zod";

export const getCollectionById = {
  name: "getCollectionById" as const,
  input: z.object({ id: z.string(), provider: z.enum(Provider).optional() }),
  output: z.object({ id: z.string(), name: z.string() }).nullable(),
};
